const HOST = "https://training.cleverland.by/shop/";

const API = {
    products: `${HOST}products`,
    sendEmail: `${HOST}email`,
    sendReview: `${HOST}product/review`,
    sendOrder: `${HOST}cart`,
    getCountries: `${HOST}countries`,
    getCities: `${HOST}search/cities`
};

export default API;

